<div *ngIf="isPanelOpen" class="panel-backdrop" [@fadeBackdrop] (click)="closePanel()"></div>

<div *ngIf="isPanelOpen" class="panel-container" [@slidePanel] [class.expanded]="isReadingPaneOpen"
     role="dialog" aria-modal="true" aria-labelledby="outlook-panel-title"
     cdkTrapFocus [cdkTrapFocusAutoCapture]="true">

  <!-- ─── Header ─── -->
  <div class="panel-header">
    <mat-icon class="panel-header__icon">mail_outline</mat-icon>
    <div class="panel-header__title">
      <h2 id="outlook-panel-title">Outlook</h2>
      <span class="panel-header__account" *ngIf="account" [matTooltip]="account.username">
        {{ account.username }}
      </span>
    </div>
    <button mat-icon-button matTooltip="Open Outlook on the web" aria-label="Open Outlook on the web" (click)="openOutlookWeb()">
      <mat-icon>open_in_new</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Close" aria-label="Close Outlook panel" (click)="closePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ─── Tabs. Labels appear only once the panel widens; below that the tooltip carries them. ─── -->
  <nav class="panel-tabs" *ngIf="connection === 'connected'">
    <button *ngFor="let tab of tabsList"
            class="panel-tab"
            [class.panel-tab--active]="activeTab === tab.key"
            [matTooltip]="tab.label"
            [attr.aria-label]="tab.label"
            [attr.aria-current]="activeTab === tab.key ? 'page' : null"
            (click)="setTab(tab.key)">
      <mat-icon>{{ tab.icon }}</mat-icon>
      <span class="panel-tab__label">{{ tab.label }}</span>
    </button>
  </nav>

  <!-- ─── Body ─── -->
  <div class="panel-body">

    <app-outlook-connect-state *ngIf="connection !== 'connected'"
                               [state]="connection"
                               [busy]="connecting"
                               (connect)="onConnect()"
                               (retry)="onRetry()"
                               (signOut)="onSignOut()">
    </app-outlook-connect-state>

    <ng-container *ngIf="connection === 'connected'">
      <app-outlook-mail-tab      *ngIf="activeTab === 'mail'"></app-outlook-mail-tab>
      <app-outlook-calendar-tab  *ngIf="activeTab === 'calendar'"></app-outlook-calendar-tab>
      <app-outlook-contacts-tab  *ngIf="activeTab === 'contacts'"></app-outlook-contacts-tab>
      <app-outlook-profile-tab   *ngIf="activeTab === 'profile'"></app-outlook-profile-tab>
      <app-outlook-signature-tab *ngIf="activeTab === 'signature'"></app-outlook-signature-tab>
    </ng-container>

  </div>
</div>
